import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    DataTable,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    CardHeading,
    PlusButton,
} from '@ucc/react/ui';
import { usePermission, useViewer } from '~/hooks';
import { HasPermission } from '~/layout/HasPermission';
import { GoToScheduleButton } from '~/pages/projects/components/GoToScheduleButton';
import { useCorrespondence } from '../hooks/useCorrespondence';

export function Correspondence({ disableScheduleButton, ...props }: any) {
    const { onCreate, openDraft, ...dataTableProps } = useCorrespondence({
        subprojectId: props.subprojectId,
        pxProjectId: props.projectId,
    });
    const location = useLocation();
    const navigate = useNavigate();

    // The PX Connect Schadenbericht flow navigates here with a prepared draft in
    // location.state; open the Korrespondenz modal through useCorrespondence so it
    // gets the mutation props, then clear the state so a back/refresh won't reopen.
    React.useEffect(() => {
        const row = (location.state as any)?.openCorrespondenceModal?.row;
        if (!row || !props.subprojectId) return;
        openDraft(row);
        navigate(
            { pathname: location.pathname, search: location.search },
            { replace: true, state: null }
        );
    }, [location.state, location.pathname, location.search, navigate, openDraft, props.subprojectId]);

    const viewer = useViewer();
    const hasEditAllCorrespondence = viewer.hasPermission(
        'additional.editAllCorrespondence',
        'enabled'
    );
    const { canCreate } = usePermission('project.correspondence');
    const canEditCorrespondence = canCreate || hasEditAllCorrespondence;

    return (
        <HasPermission resource="project.correspondence" permission="view">
            <Card boxShadow="none">
                <CardHeader>
                    <CardHeading>Korrespondenz</CardHeading>
                    <CardActions>
                        <HasPermission resource="project.schedule" permission="create">
                            <GoToScheduleButton state={props} isDisabled={disableScheduleButton} />
                        </HasPermission>
                        {canEditCorrespondence && (
                            <PlusButton onClick={onCreate}>Neue Korrespondenz</PlusButton>
                        )}
                    </CardActions>
                </CardHeader>
                <CardContent>
                    <DataTable {...dataTableProps} />
                </CardContent>
            </Card>
        </HasPermission>
    );
}
